import { FormControl, Box } from "@mui/material";
import _ from "lodash";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import ChooseFormulaModal from "@/components/membership/ChooseFormulaModal/ChooseFormulaModal";
import {
  OperatorSelector,
  NumberInput,
  DateInput,
  TextInput,
  ColumnSelector,
  ColumnTextInput,
} from "@/components/membership/Template/templateInputs";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

import "@/components/membership/Template/TemplateInput.css";

const inputMap = {
  column: ColumnSelector,
  text: TextInput,
  "column-text": ColumnTextInput,
  integer: NumberInput,
  float: NumberInput,
  date: DateInput,
  operator: OperatorSelector,
};

function TemplateInput({
  row,
  rowIndex,
  handleInputChange,
  formulae,
  saveFormula,
}) {
  const { affiliateFileData, politicalData, workflow } = useUpdateDataContext();
  const columnNames =
    workflow === "political"
      ? politicalData.columns
      : affiliateFileData.columns;
  const [affiliateColumns, setAffiliateColumns] = useState([]);
  const [inputPattern, setInputPattern] = useState([]);

  useEffect(() => {
    const pattern = _.get(formulae, [row.formula, "pattern"]);
    setInputPattern(pattern);
  }, [row.formula, formulae]);

  useEffect(() => {
    setAffiliateColumns(row.affiliate_columns ?? []);
  }, [row.affiliate_columns]);

  const getValueForInputDisplay = (index) => {
    return affiliateColumns && affiliateColumns[index]
      ? affiliateColumns[index].replace(/^@:/, "")
      : null;
  };

  const addStringLiteralIndicators = (newInputValue) => {
    if (!columnNames.includes(newInputValue) && newInputValue !== null) {
      return "@:" + newInputValue;
    }
    return newInputValue;
  };

  const concatenatedValue = () => {
    const presentableArray = affiliateColumns.map((col, index) =>
      getValueForInputDisplay(index)
    );
    return presentableArray.join("");
  };

  const handleChange = (newInputValue, inputIndex) => {
    newInputValue = addStringLiteralIndicators(newInputValue);
    setAffiliateColumns((prevColumns) => {
      const newColumns = [...prevColumns];
      newColumns[inputIndex] = newInputValue;
      // callback to Template Mapper
      handleInputChange(newColumns, rowIndex);
      return newColumns;
    });
  };

  if (row.formula === "lookup") {
    const affiliate_columns = !row.affiliate_columns
      ? []
      : row.affiliate_columns;
    return (
      <>
        <span className="affiliate-column-string">
          {affiliate_columns.join(", ")}
        </span>
        <ChooseFormulaModal
          row={row}
          rowIndex={rowIndex}
          saveFormula={saveFormula}
          openLookupDirectly={true}
          formulae={formulae}
        />
      </>
    );
  }
  return (
    <>
      {inputPattern &&
        inputPattern.map((inputType, index) => {
          // create Input according to input type (text, column, number, etc)
          const InputComponent = inputMap[inputType];
          const value = getValueForInputDisplay(index);
          return (
            <FormControl
              key={index}
              sx={{ m: 1, minWidth: 120, backgroundColor: "white" }}
              size="small"
            >
              <InputComponent
                inputIndex={index}
                handleChange={handleChange}
                value={value}
                disabled={!!row.disabled}
              />
            </FormControl>
          );
        })}
      {row.formula === "concatenate" && (
        <Box sx={{ textAlign: "right" }}>{concatenatedValue()}</Box>
      )}
    </>
  );
}

TemplateInput.propTypes = {
  row: PropTypes.object,
  rowIndex: PropTypes.number,
  handleInputChange: PropTypes.func,
  formulae: PropTypes.object,
  setIndexOfCousinModalToOpen: PropTypes.func,
};

export default TemplateInput;
